export const QUICK_AMOUNTS = [100, 500, 1000];

// OnRamper fiat rails (deposit via card, withdrawal via bank). Defaults ON so
// UAT/dev show the card option without needing a build-time env var set; prod
// turns it OFF explicitly with NEXT_PUBLIC_ONRAMPER_PAYMENTS_ENABLED=false until
// credentials are confirmed renewed (mirrors MOONPAY_ENABLED's `!== 'false'`
// pattern). Previously this was a hardcoded 'true' literal; the earlier `=== 'true'`
// fix hid the option on any build where the env var wasn't set, which broke UAT.
export const ONRAMPER_PAYMENTS_ENABLED =
  process.env.NEXT_PUBLIC_ONRAMPER_PAYMENTS_ENABLED !== 'false';

// MoonPay headless fiat rails (bank/card deposit on-ramp + bank withdrawal off-ramp).
// Default ON for UAT; set NEXT_PUBLIC_MOONPAY_ENABLED=false to hide.
export const MOONPAY_ENABLED = process.env.NEXT_PUBLIC_MOONPAY_ENABLED !== 'false';

// MoonPay's bank rail is temporarily unreliable (Aug 2026) — keep the deposit
// "Bank or card" option visible so the user understands why, but disable it
// with a "temporarily unavailable" notice instead of silently hiding it. Set
// NEXT_PUBLIC_MOONPAY_BANK_TRANSFER_RESTRICTED=false (or flip this) once MoonPay is stable.
// (MoonPay bank *withdrawal* was removed 2026-08-24 — wallet-to-bank withdrawals
// moved back to OnRamper, see ONRAMPER_PAYMENTS_ENABLED.)
export const MOONPAY_BANK_TRANSFER_RESTRICTED =
  process.env.NEXT_PUBLIC_MOONPAY_BANK_TRANSFER_RESTRICTED !== 'false';

export const STATIC_COUNTRIES = [
  { code: 'US', name: 'United States' },
  { code: 'IN', name: 'India' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'CA', name: 'Canada' },
  { code: 'AU', name: 'Australia' },
  { code: 'MX', name: 'Mexico' },
  { code: 'BR', name: 'Brazil' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'JP', name: 'Japan' },
];
